import React from 'react';

/**
 * CHG-150 Phase B-1: 평문 텍스트에서 URL을 감지해 클릭 가능한 링크로 변환.
 *
 * 정규식 정책 (보수적):
 *  - `https?://` 시작 + 공백/기호 경계까지
 *  - 끝 구두점(`.,;!?`)은 URL에서 제외 (false positive 회피)
 *  - 따옴표/꺽쇠 등 HTML 경계도 제외
 *
 * 본 함수는 React.ReactNode[] 반환 — caller는 그대로 children에 배치.
 */
const URL_REGEX = /https?:\/\/[^\s<>"]+[^\s<>".,;!?]/g;

export function linkifyText(text: string, keyPrefix = 'lnk'): React.ReactNode[] {
  if (!text) return [];

  const result: React.ReactNode[] = [];
  let lastIdx = 0;
  let matchIdx = 0;

  for (const match of text.matchAll(URL_REGEX)) {
    const url = match[0];
    const start = match.index ?? 0;

    if (start > lastIdx) {
      result.push(text.substring(lastIdx, start));
    }

    result.push(
      <a
        key={`${keyPrefix}-${matchIdx}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:underline break-all"
        onClick={(e) => e.stopPropagation()}
      >
        {url}
      </a>,
    );

    lastIdx = start + url.length;
    matchIdx += 1;
  }

  if (lastIdx < text.length) {
    result.push(text.substring(lastIdx));
  }

  return result.length > 0 ? result : [text];
}
